module.exports = __webpack_public_path__ + "static/UBI-Vector1.58f8a67f.svg";